import {defaultTheme} from '@stencil/build-theme/src/build-theme';
import {useSelector} from 'react-redux';

//Icons
import ReserverNowPayLaterIcon from '../../../../../Icons/ReserveNowPayLater';

//config
import {bnplInfo} from '@stencil/hotels-config/src';

//styles
import * as S from './BookNowPayLater.styles';

const BookNowPayLater = ({text}) => {
  return (
    <S.BookNowPayLaterPersuasionWrap>
      <ReserverNowPayLaterIcon
        fill={defaultTheme.colors.goTeal.dark}
        width="2.7rem"
        height="2.7rem"
      />
      <S.BookNowPaylaterRightwrap>
        {/* <S.BookNowPayLaterText>{bnplInfo}</S.BookNowPayLaterText> */}
        <S.BookNowPayLaterText>{text}</S.BookNowPayLaterText>
        <S.BookNowPaylaterKnowmoreWrap>Risk Free Booking!</S.BookNowPaylaterKnowmoreWrap>
      </S.BookNowPaylaterRightwrap>
    </S.BookNowPayLaterPersuasionWrap>
  );
};

export default BookNowPayLater;
